import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import './SettingsStyles.scss';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router';
import classNames from 'classnames';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  getFilterData,
  getPaginationOpts,
  getResponseError,
  responseLogWithNotification,
  useUpdatePeriod,
} from '../../../utils/utils';
import { getSystemData } from '../../System/reducer';
import { deleteSettings, loadSettings } from '../actions';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import { showGlobalConfirm } from '../../System/actions';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import Tooltip from '../../../components/base/Tooltip/Tooltip';
import SettingsForm from './SettingsForm';
import { getSettingsData } from '../reducer';
import { SETTINGS_MODULE } from '../../../configs/moduleNames';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import TimerLoader from '../../../components/base/Loader/TimerLoader';
import TextSearchInput from '../../../components/fields/TextInput/TextSearchInput';

export default function SettingsPage(props) {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const store = useStore();
  const [showForm, setShowForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedCat, setSelectedCat] = useState(null);
  const [selected, setSelected] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [linkMenu, setLinkMenu] = useState(null);
  const search = searchParams.get('search');

  const { updatePeriod } = useSelector(getSystemData);
  const {
    loadingCreateSettings,
    loadingDeleteSettings,
    loadingSettingsList,
    loadingEditSettings,
    loadingCurrentSettings,
    settingsList = [],
  } = useSelector(getSettingsData);

  const {
    getValues, control, watch, setValue, reset,
  } = useForm({ defaultValues: getFilterData('application-filter', {}) });

  const loadData = opts => {
    const filterData = getValues();
    const paginationOpts = getPaginationOpts(store.getState()[SETTINGS_MODULE].settingsListMeta, opts); // костыль внедрен из за потери контекста в updatePeriod. Он сохранял первую функцию
    const requestData = {
      ...paginationOpts,
      filter: filterData,
    };
    const p1 = dispatch(loadSettings(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);
  useEffect(() => {
    const subscription = watch(values => loadData({ page: 1 }));
    return () => subscription.unsubscribe();
  }, [watch]);
  useEffect(() => setValue('search', search), [search]);

  const handleCreate = event => {
    setShowForm(true);
    setIsEdit(false);
    setSelected(null);
  };

  const handleEdit = item => event => {
    handleClose();
    if (!item) {
      return;
    }
    setSelected(item);
    setShowForm(true);
    setIsEdit(true);
  };

  const handleDelete = item => event => {
    dispatch(showGlobalConfirm({
      confirmMessage: `Удаление настройки ${item.key}`,
      confirmButtonText: 'Удалить',
      confirmClassName: 'remove-preset',
    })).then(() => {
      dispatch(deleteSettings(item.id)).then(() => {
        loadData();
        successNotification('Удаление настройки', 'Удаление прошло успешно');
      }).catch(response => {
        errorNotification('Удаление настройки', getResponseError(response));
      });
    }).catch(() => {});
    return false;
  };

  const handleClose = item => {
    setIsEdit(false);
    setShowForm(false);
    setSelected(null);
    setSearchParams(search ? { search } : {});
  };

  const getCategoryList = () => {
    const filteredOptionsList = search ? settingsList.filter(option => (String(option.name).toLowerCase().includes(String(search).toLowerCase()) || String(option.name_label).toLowerCase().includes(String(search).toLowerCase()))) : [...settingsList];
    const category = filteredOptionsList.reduce((prev, current) => {
      const index = prev.findIndex(item => item.group === current.group);
      if (index >= 0) {
        prev[index].list.push(current);
      } else {
        prev.push({ group: current.group, group_label: current.group_label, list: [current] });
      }
      return prev;
    }, []);
    const sortedCategory = category.sort((a, b) => {
      if (a.group_label < b.group_label) { return -1; }
      if (a.group_label > b.group_label) { return 1; }
      return 0;
    });
    if (sortedCategory && sortedCategory[0] && sortedCategory[0].group_label === '') {
      sortedCategory.push(sortedCategory.shift());
    }
    return sortedCategory;
  };

  const columnTooltipFormatter = a => (
    <Tooltip content={a.toString()} className="column-tooltip c300 tbl" />
  );

  const renderContextMenu = item => (
    <div className="more-wrapper">
      <Button variant="link" className="w-100 more-button" onClick={handleEdit(item)}>
        Редактировать
      </Button>
      {/* <Button variant="link" className="w-100 more-button delete" onClick={handleDelete(item)}> */}
      {/*  Удалить */}
      {/* </Button> */}
    </div>
  );

  const moreFormatter = (_, item) => (
    <TooltipWithPortal
      content={<Icons customIcon icon="more-vert" className="more-vert" />}
      classNamePortal="more-actions"
      tooltipContent={renderContextMenu(item)}
      classNameWrapper="more-tooltip-wrapper"
      className="more-tooltip"
    />
  );

  const columns = [
    {
      dataField: 'name',
      text: 'Ключ опции',
      disableSort: true,
    },
    {
      dataField: 'name_label',
      text: 'Название',
      disableSort: true,
    },
    {
      dataField: 'payload',
      text: 'Значение',
      disableSort: true,
      formatter: columnTooltipFormatter,
    },
  ];

  const groups = getCategoryList();

  useEffect(() => {
    if (groups && groups.length) {
      setSelectedCat(selectedCat || groups[0]);
    }
  }, [groups]);

  const findGroup = selectedCat ? groups.find(i => i.group === selectedCat.group) : null;
  const selectedSettings = selectedCat && findGroup ? findGroup.list : [];

  return (
    <div className="page settings-page">
      <TimerLoader loading={loadingCreateSettings || loadingDeleteSettings || loadingSettingsList || loadingEditSettings || loadingCurrentSettings} />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.settings' })}</div>
        <FilterRow>
          <FieldDTO
            control={control}
            component={TextSearchInput}
            dtoObject={{
              name: 'search',
              type: String,
              labelKey: 'search',
            }}
            className="no-border"
            inputProps={{
              value: search || '',
              onChange: e => setSearchParams(e.target.value ? { search: e.target.value || '' } : {}),
            }}
          />
        </FilterRow>
      </div>
      <div className="page-content-wrapper">
        <div className="page-content settings-content">
          <div className="settings-category-wrapper frame">
            <div className="settings-category-header">Разделы</div>
            <div className="settings-category-list">
              {groups.map((item, key) => {
                const active = selectedCat ? selectedCat.group === item.group : false;
                return (
                  <div key={key} className={classNames('category-list-item', { active })} onClick={() => { setSelectedCat(item); setLinkMenu(false); }}>
                    <Tooltip content={item.group_label || 'Без категории'} className="option-tooltip" />
                  </div>
                );
              })}
              <div className={classNames('category-list-item link ', { active: linkMenu })} onClick={() => { window.location.href = 'https://admin.asugpt.orgp.spb.ru/'; }}>
                Админская панель АСУ ГПТ
                <Icons width={24} height={24} customIcon icon="asu-link" />
              </div>
              <div className={classNames('category-list-item link ', { active: linkMenu })} onClick={() => { window.location.href = 'https://analytics.asugpt.orgp.spb.ru/'; }}>
                Переход к витрине
                <Icons width={24} height={24} customIcon icon="asu-link" />
              </div>
            </div>
          </div>
          <div className="settings-list-wrapper frame">
            <div className="settings-list-wrapper-header">Настройка раздела {selectedSettings[0]?.group_label || ''}</div>
            <div className="grid-wrapper">
              <div className="custom-scroll-theme sticky-table-wrapper">
                <CustomizedGrid
                  onDoubleClickByRow={(item, event) => handleEdit(item)(event)}
                  data={selectedSettings}
                  columns={columns}
                  name="application-list"
                  settingsFormatter={moreFormatter}
                  renderContextMenu={renderContextMenu}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {showForm ? <SettingsForm key={selected && selected.key ? selected.key : ''} current={selected} isEdit={isEdit} close={handleClose} loadData={loadData} /> : null}
    </div>
  );
}
